import { ICustomPageAddEditRequest } from '../../../../model/apm/custom-page/request/custom-page-add-edit-request';
import { ICustomPageResponse } from '../../../../model/apm/custom-page/response/custom-page-response';
import { ICustomPageSectionResponse } from '../../../../model/apm/custom-page/response/custom-page-section-response';
import { ICustomPageSectionItemResponse } from '../../../../model/apm/custom-page/response/custom-page-section-item-response';

export type CustomPageCreateEditState = {
    customPageId?: string;
    pageRequest: ICustomPageAddEditRequest;
    page?: ICustomPageResponse;
    sections: ICustomPageSectionResponse[];
    showValidationErrors: boolean;
    sectionDrawer: { open: boolean; section?: ICustomPageSectionResponse };
    itemDrawer: { open: boolean; section?: ICustomPageSectionResponse; item?: ICustomPageSectionItemResponse };
};

export enum ACTION_TYPES {
    setCustomPageId = 'setCustomPageId',
    setPage = 'setPage',
    updatePageRequest = 'updatePageRequest',
    setShowValidationErrors = 'setShowValidationErrors',
    setSections = 'setSections',
    setSectionItems = 'setSectionItems',
    openSectionDrawer = 'openSectionDrawer',
    closeSectionDrawer = 'closeSectionDrawer',
    openItemDrawer = 'openItemDrawer',
    closeItemDrawer = 'closeItemDrawer',
}

export const CustomPageCreateEditReducer = (state: CustomPageCreateEditState, action: any): CustomPageCreateEditState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setCustomPageId:
            return { ...state, customPageId: payload, showValidationErrors: false };
        case ACTION_TYPES.setPage: {
            const page: ICustomPageResponse = payload;
            return {
                ...state,
                page,
                sections: page.sections ?? state.sections,
                pageRequest: {
                    title: page.title,
                    slug: page.slug,
                    summary: page.summary,
                    metaDescription: page.metaDescription,
                    metaKeywords: page.metaKeywords,
                    coverImage: page.coverImage,
                    order: page.order,
                },
            };
        }
        case ACTION_TYPES.updatePageRequest:
            return { ...state, pageRequest: { ...state.pageRequest, ...payload } };
        case ACTION_TYPES.setShowValidationErrors:
            return { ...state, showValidationErrors: payload };
        case ACTION_TYPES.setSections:
            return { ...state, sections: payload };
        case ACTION_TYPES.setSectionItems:
            return {
                ...state,
                sections: state.sections.map((s) => (s.id === payload.sectionId ? { ...s, items: payload.items } : s)),
            };
        case ACTION_TYPES.openSectionDrawer:
            return { ...state, sectionDrawer: { open: true, section: payload } };
        case ACTION_TYPES.closeSectionDrawer:
            return { ...state, sectionDrawer: { open: false } };
        case ACTION_TYPES.openItemDrawer:
            return { ...state, itemDrawer: { open: true, section: payload.section, item: payload.item } };
        case ACTION_TYPES.closeItemDrawer:
            return { ...state, itemDrawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
